import React from 'react';
import "./empty-content.scss";

const EmptyContent = (props: any) => {

    return (
        <div className="map-empty-content">
            <div className="msg-block">
                <div>
                    <i className="fas fa-road icon-road"></i>
                </div>

                <div>
                    <b>Select a session </b> from the list
                </div>
                
                <div>
                    to see its information
                </div>
            </div>
        </div>
    )
}

export default React.memo(EmptyContent);


